import TaskCardSkeleton from "@/components/task-card/TaskCardSkeleton";

/**
 * PageSkeleton — route-level loading placeholder for task pages.
 * Mirrors the exact Index page frame (container padding, title block, mode toggle)
 * so that when Index mounts there is ZERO layout shift and the user perceives
 * a single continuous skeleton instead of two different ones.
 */
const PageSkeleton = () => (
  <div className="relative container mx-auto px-4 pt-20 pb-8 md:pt-28 md:pb-12">
    {/* Page title block — same geometry as Index */}
    <div className="text-center mb-10 md:mb-14 flex flex-col items-center">
      <div className="h-10 md:h-12 w-56 md:w-72 rounded-lg bg-muted animate-pulse mb-3" />
      <div className="h-5 md:h-6 w-64 md:w-80 rounded bg-muted animate-pulse" />
      <div className="mt-4 h-9 w-72 rounded-full bg-muted animate-pulse" />
    </div>

    <div className="max-w-3xl lg:max-w-4xl mx-auto">
      <TaskCardSkeleton />
    </div>
  </div>
);

export default PageSkeleton;
